export const FROM_COLLABORATION_NOTIFICATION = 'FROM_COLLABORATION_NOTIFICATION';
